import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
    HhsgSharedApplicationsService,
    HhsgSharedClientAdminService,
    HhsgSharedConfigService,
    HhsgSharedCorporationService,
    HhsgSharedFormStateService,
    HhsgSharedStuderEmployeeService,
    HhsgSharedTabControlService,
    HhsgSharedUserAdministratorService,
    HhsgSharedUserAdminService,
    HhsgSharedUserService
} from '../../../services';
import { HhsgSharedTabInterface } from '../../common/tab-control/tab.interface';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { DevExtremeUtils } from '../../../utilities/dev-extreme.util';
import { HhsgSharedEditUserBase } from './edit-user-base.component';

@Component({
    selector: 'hhsg-material-edit-user',
    templateUrl: './material-edit-user.component.html',
    styleUrls: ['./material-edit-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HhsgSharedMaterialEditUserComponent extends HhsgSharedEditUserBase implements OnDestroy, OnInit, HhsgSharedTabInterface {
    @ViewChild('form', { static: false }) form: DxFormComponent;

    private dxFormIsValid: boolean = true;
    
    constructor(
        public _activatedRoute: ActivatedRoute,
        public _applicationService: HhsgSharedApplicationsService,
        public _clientAdminService: HhsgSharedClientAdminService,
        public _configService: HhsgSharedConfigService,
        private _corporationService: HhsgSharedCorporationService,
        private _employeeService: HhsgSharedStuderEmployeeService,
        private _formStateService: HhsgSharedFormStateService,
        private _router: Router,
        private _tabControlService: HhsgSharedTabControlService,
        private _userAdministratorService: HhsgSharedUserAdministratorService,
        public _userAdminService: HhsgSharedUserAdminService,
        private _userService: HhsgSharedUserService,
        private _formBuilder: UntypedFormBuilder,        
        private _changeDetector: ChangeDetectorRef) {
        super( _activatedRoute,
            _applicationService,
            _clientAdminService,
            _configService,
            _corporationService,
            _employeeService,
            _formStateService,
            _router,
            _tabControlService,
             _userAdministratorService,
             _userAdminService,
             _userService,
             _formBuilder, 
             _changeDetector);
        
             this.isEmailValid = true;
    }

    initializeFormGroup() {        
        this.formGroup = new UntypedFormGroup({
        });
    }

    public override isFormValid(): boolean {
        return this.formGroup.valid && this.dxFormIsValid;
    }

    protected override afterSaveSuccess(): void {        
        this._formStateServiceBase.isFormDirty = false;
        this.dxFormIsValid = false;
        this._changeDetectorBase.detectChanges();
    }

    protected override initializeControls(): void {
        if (this.activeUser) {
            this.isShowDormant = this.activeUser.isDormant && this.activeUser.isActive;

            if (this._userAdminServiceBase.ClientsWithApplications) {
                this._userAdminServiceBase.ClientsWithApplications.forEach(c => {
                    let control = this.formGroup.controls[this.getClientControlName(c.client.id)];

                    if (control) {
                        control.reset({ disabled: this.isFormDisabled, value: !this.isAdding && this.isClientChecked(c.client.id) });
                    }
                });

                let applications = this._userAdminServiceBase.ClientsWithApplications.flatMap(c => c.clientApplications);

                if (!this.isAdding && applications && applications.length > 0) {
                    applications.forEach(a => {
                        let control = this.formGroup.controls[this.getApplicationControlName(a.clientId, a.applicationId)];

                        if (control) {
                            control.reset({ disabled: this.isFormDisabled, value: this.isApplicationChecked(a.clientId, a.applicationId) });
                        }
                    })
                }
            }
        }
    }

    public getIsFormGroupDirty() : boolean {
        return this._formStateServiceBase.isFormDirty;
    }

    public onFieldDataChanged(e) {
        if (this.isLoading) {
            // Only check to see if the form is valid after its done loading.
            return;
        }
        let result = e.component.validate();
        if (result.brokenRules.length >= 1) {
            this.dxFormIsValid = false;
        } else {
            this.dxFormIsValid = true;
        }
        this._formStateServiceBase.isFormDirty = true;
    }

    public userRoleEditorOptions() {
        return {
            items: this.editableUserRoles,
            displayExpr: 'friendlyName',
            valueExpr: 'roleName',
            stylingMode: DevExtremeUtils.DevExtremeStyleMode
        };
    }

    public statusEditorOptions() {    
        return {
            items: [
                { name: 'Active', value: true },
                { name: 'Inactive', value: false }
            ],
            displayExpr: 'name',
            valueExpr: 'value',
            stylingMode: DevExtremeUtils.DevExtremeStyleMode
        };
    }

    public ssoUserEditorOptions() {
        return {
            items: [
                { name: 'Yes', value: false },
                { name: 'No', value: true }
            ],
            displayExpr: 'name',
            valueExpr: 'value',
            stylingMode: DevExtremeUtils.DevExtremeStyleMode
        };
    }

}
